import React from 'react';
import testIcon from '../../../images/test-icon.png';
import winsonPhoto from '../../../images/Ellipse 1.png';
import ritaPhoto from '../../../images/Ellipse 2.png';
import karolePhoto from '../../../images/Ellipse 3.png';
import TestimonialCard from '../TestimonialCard/TestimonialCard';

const Testimonial = () => {
    const testData = [
        {
            name: "Winson Herry",
            img: winsonPhoto
        },
        {
            name: "Rita Bennette",
            img: ritaPhoto
        },
        {
            name: "Karole Holmes",
            img: karolePhoto
        }
    ]

    return (
        <div className='mt-5 pt-5 container' >
            <h5 className='head-color fw-bold'>TESTIMONIAL</h5>
            <div className='d-flex justify-content-between'>
                <h1 style={{fontSize:'50px'}}>What's Our Patient <br /> Says</h1>
                <img style={{height:'180px', marginTop:'-50px'}} className='img-fluid' src={testIcon} alt="" />
            </div>
            <div className="row mt-5 pt-3 mb-5">
                {
                    testData.map(item => <TestimonialCard item={item}></TestimonialCard>)
                }
            </div>
        </div>
    );
};

export default Testimonial;